import React, { createContext, useContext, useState, useEffect } from 'react';

const HomepageVersionContext = createContext('full');

export function HomepageVersionProvider({ children }) {
  const [version, setVersion] = useState(() => {
    // 初回レンダリング時にローカルキャッシュを使って点滅を防ぐ
    return localStorage.getItem('homepage_version') || 'full';
  });

  useEffect(() => {
    fetch('/api/settings')
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        const v = data?.homepage_version || 'full';
        setVersion(v);
        localStorage.setItem('homepage_version', v);
      })
      .catch(() => {});
  }, []);

  return (
    <HomepageVersionContext.Provider value={version}>
      {children}
    </HomepageVersionContext.Provider>
  );
}

export function useHomepageVersion() {
  return useContext(HomepageVersionContext);
}
